var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useState } from 'react';
import { ApolloError } from 'shared/domains/apollo/ApolloError';
import { parseGraphqlResult } from 'shared/domains/apollo/parseGraphqlResult';
import { documentFlush, usePreview } from 'shared/domains/documents';
import { CreateSignRequestErrors, HANDLED_ERRORS } from '../types';
import { useCreateSignRequest } from '../useCreateSignRequest';
export const useSendForEsigning = (documentId) => {
    const { createSignRequest, convertToPdf } = useCreateSignRequest();
    const { isRtcAvailable } = usePreview();
    const [loading, setLoading] = useState(false);
    const [submitCount, setSubmitCount] = useState(0);
    const [creationError, setCreationError] = useState();
    const [creationFailedSubcode, setCreationFailedSubcode] = useState();
    const [creationRejectionReasons, setCreationRejectionReasons] = useState([]);
    const convertDocumentToPdf = () => __awaiter(void 0, void 0, void 0, function* () { return convertToPdf(documentId); });
    const sendForEsigning = (pdf) => __awaiter(void 0, void 0, void 0, function* () {
        var _a;
        if (isRtcAvailable) {
            documentFlush({ state: 'initialized' });
        }
        setLoading(true);
        setCreationError(undefined);
        setCreationFailedSubcode(undefined);
        setCreationRejectionReasons([]);
        setSubmitCount((current) => current + 1);
        try {
            const result = yield createSignRequest(documentId, pdf);
            const [, rejection] = parseGraphqlResult((_a = result.data) === null || _a === void 0 ? void 0 : _a.createSignRequest, 'CreateSignRequestPayload', 'CreateSignRequestRejectionList');
            if (rejection) {
                setCreationRejectionReasons(rejection.rejections.map((r) => r.reason));
                return false;
            }
            return true;
        }
        catch (error) {
            if (error instanceof ApolloError && HANDLED_ERRORS.includes(error.message)) {
                setCreationError(error.message);
            }
            else {
                setCreationError(CreateSignRequestErrors.UnexpectedError);
            }
            return false;
        }
        finally {
            setLoading(false);
        }
    });
    return {
        sendForEsigning,
        convertDocumentToPdf,
        loading,
        submitCount,
        creationError,
        creationFailedSubcode,
        creationRejectionReasons,
        setCreationFailedSubcode,
    };
};
